import script from "./CountersUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./CountersUsers.vue?vue&type=script&setup=true&lang=js"

import "./CountersUsers.vue?vue&type=style&index=0&id=4c1d6eec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c1d6eec"]])

export default __exports__